import React, { useState, useEffect, useRef } from "react";
import { Delete01Icon, PencilEdit02Icon, Calendar03Icon, ViewIcon } from "hugeicons-react";
import "../../assets/css/position/position.css";
import DeletePositionPopup from "../positionPopup/DeletePositonPopup";
import { isAdminOrSuperUser } from "../../services/userPosition";
 
const PositionCard = ({ id, name, description, dateCreated, onEditClick, onDelete, onView }) => {
    const [showOptions, setShowOptions] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [showViewPopup, setShowViewPopup] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);
 
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                showOptions &&
                dropdownRef.current &&
                buttonRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !buttonRef.current.contains(event.target)
            ) {
                setShowOptions(false);
            }
        };
 
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showOptions]);
 
    const toggleOptions = (event) => {
        event.stopPropagation();
        setShowOptions(!showOptions);
    };
 
    const handleEditClick = (event) => {
        event.stopPropagation();  
        onEditClick({ id, name, description, dateCreated });
        setShowOptions(false);
    };
 
    const handleDeleteClick = (event) => {
        event.stopPropagation();  
        setShowDeletePopup(true);
        setShowOptions(false);
    };
    const handleViewClick = (event) => {
        event.stopPropagation();
        onView({ id, name, description, dateCreated });
        setShowOptions(false);
    };
    
    const handleConfirmDelete = async () => {
        setIsSubmitting(true);
        try {
            await onDelete(id);
            setShowDeletePopup(false);
        } catch (error) {
            console.error("Delete failed", error);
        } finally {
            setIsSubmitting(false);
        }
    };
 
    const handleClosePopup = () => {
        setShowDeletePopup(false);
    };
 
    return (
        <div className="position-card">
            <div className="position-card-header">
                <h3 className="position-name">{name}</h3>
                <p className="position-menu-trigger" onClick={toggleOptions} ref={buttonRef}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', color: 'inherit' }}>
                        <circle cx="12" cy="5" r="2" fill="currentColor"/>
                        <circle cx="12" cy="12" r="2" fill="currentColor"/>
                        <circle cx="12" cy="19" r="2" fill="currentColor"/>
                    </svg>
                </p>
            </div>
            <div className="position-contents">
                <p className="position-description">{description}</p>
            </div>
            <hr />
            <div className="position-meta">
                <Calendar03Icon size={18} />
                <span>{dateCreated}</span>
            </div>
            {showOptions && (
                <div className="position-data" id="popup-overlay" ref={dropdownRef}>
                    <div className="action-button">
                        <div className="delete" onClick={handleViewClick}>
                            <p className="edit-text"><ViewIcon /> View details</p>
                        </div>
                        {
                            isAdminOrSuperUser?
                            <>
                                <div className="edit" onClick={handleEditClick}>
                                    <p className="edit-text"><PencilEdit02Icon /> Edit</p>
                                </div>
                                <div className="line"></div>
                                <div className="delete" onClick={handleDeleteClick}>
                                    <p><Delete01Icon /> Delete</p>
                                </div>                      
                            </>
                            :
                            <></>
 
                        }
                    </div>
                </div>
            )}
            {showDeletePopup && (
                <DeletePositionPopup
                    positionId={id}
                    onClose={handleClosePopup}
                    onDelete={handleConfirmDelete}
                    isSubmitting={isSubmitting}
                />
            )}
        </div>
    );
};
 
export default PositionCard;
 